import UploadMedia from './upload-media';

export default UploadMedia;